import {request} from "./request";

// 客户群标签
// 客户群标签列表
export function getCustomerBaseTagList(pagesize, page) {
    return request({
        url: '/hkt/customerbasetag/get_customer_base_tag_list',
        params: {
            pagesize,
            page
        }
    })
}
// 添加客户群标签
export function addCustomerBaseTag(tag_group_name, tag_name) {
    return request({
        url: '/hkt/customerbasetag/add_customer_base_tag',
        params: {
            tag_group_name,
            tag_name
        }
    })
}
// 删除客户群标签
export function delCustomerBaseTag(group_id) {
    return request({
        url: '/hkt/customerbasetag/del_customer_base_tag',
        params: {
            group_id,
        }
    })
}
// 修改客户群标签
export function editCustomerBaseTag(group_id, tag_group_name, edit_tag_info, del_tag_info, add_tag_info) {
    return request({
        url: '/hkt/customerbasetag/edit_customer_base_tag',
        params: {
            group_id,
            tag_group_name,
            edit_tag_info,
            del_tag_info,
            add_tag_info
        }
    })
}

// 删人提醒
// 删人提醒列表
export function getDeleteReminderList(pagesize, page, department_id, member_id, search_time) {
    return request({
        url: '/hkt/deletereminder/get_delete_reminder_list',
        params: {
            pagesize,
            page,
            department_id,
            member_id,
            search_time,
        }
    })
}
export function getDeleteRemList(params) {
    return request({
        url: '/hkt/deletereminder/get_delete_reminder_list',
        params,
    })
}
// 删人提醒开关
export function setLossReminder2(delete_reminder) {
    return request({
        url: '/hkt/deletereminder/set_delete_reminder',
        params: {
            delete_reminder
        }
    })
}

//流失提醒
//流失提醒列表
export function getLossReminderList(pagesize, page, member_id, add_time, del_time, add_count_time) {
    return request({
        url: '/hkt/lossreminder/get_loss_reminder_list',
        params: {
            pagesize,
            page,
            member_id,
            add_time,
            del_time,
            add_count_time
        }
    })
}
//流失提醒列表2
export function getLossList(params) {
    return request({
        url: '/hkt/lossreminder/get_loss_reminder_list',
        params,
    })
}
// 流失提醒开关
export function setLossReminder1(loss_reminder) {
    return request({
        url: '/hkt/lossreminder/set_loss_reminder',
        params: {
            loss_reminder
        }
    })
}


// 客户群列表
export function getCustomerBaseList(pagesize, page, userid, tag_id, chat_name, is_lock, sort_condition, sort_type) {
    return request({
        url: '/hkt/customerbase/get_customer_base_list2',
        params: {
            pagesize,
            page,
            userid,
            tag_id,
            chat_name,
            is_lock,
            sort_condition,
            sort_type
        }
    })
}
// 打标签
export function setCustomerBaseTag(id, tag_id) {
    return request({
        url: '/hkt/customerbase/set_customer_base_tag',
        params: {
            id,
            tag_id,
        }
    })
}
// 客户群详情
export function getCustomerBaseDetails(chat_id) {
    return request({
        url: '/hkt/customerbase/get_customer_base_details',
        params: {
            chat_id
        }
    })
}
// 客户群成员列表
export function getCustomerBaseMemberList(chat_id, pagesize, page, name) {
    return request({
        url: '/hkt/customerbasemember/get_customer_base_member_list',
        params: {
            chat_id,
            pagesize,
            page,
            name
        }
    })
}
// 客户群数据按日期查看列表
export function getCustomerBaseMemberData2(chat_id, search_time) {
    return request({
        url: '/hkt/customerbasememberrecord/get_customer_base_member_record2',
        params: {
            chat_id,
            search_time,
        }
    })
}
// 客户群详情图表数据
export function getCustomerBaseMemberData(chat_id, search_time, type) {
    return request({
        url: '/hkt/customerbasememberrecord/get_customer_base_member_record',
        params: {
            chat_id,
            search_time,
            type
        }
    })
}

// 客户群群发
// 群主列表
export function getCustomerBaseLeader() {
    return request({
        url: '/hkt/customerbase/get_customer_base_leader',
        params: {

        }
    })
}
// 创建群发
export function addCustomerBaseMassSend(userid, name, content, send_type, send_time) {
    return request({
        url: '/hkt/customerbasemasssend/add_customer_base_mass_send',
        params: {
            userid,
            name,
            content,
            send_type,
            send_time
        }
    })
}
// 获取客户群群发列表
export function getCustomerBaseMassSendList(pagesize, page, name) {
    return request({
        url: '/hkt/customerbasemasssend/get_customer_base_mass_send_list',
        params: {
            pagesize,
            page,
            name
        }
    })
}
// 获取客户群群发详情
export function getCustomerBaseMassSendDetails(id) {
    return request({
        url: '/hkt/customerbasemasssend/get_customer_base_mass_send_details',
        params: {
            id
        }
    })
}
// 提醒发送
export function sendCustomerBaseMassSendRemind(id) {
    return request({
        url: '/hkt/customerbasemasssend/send_customer_base_mass_send_remind',
        params: {
            id
        }
    })
}
// 取消发送
export function setCustomerBaseMassSendState(id, state) {
    return request({
        url: '/hkt/customerbasemasssend/set_customer_base_mass_send_state',
        params: {
            id,
            state
        }
    })
}
// 记录列表
export function getCustomerBaseMassSendRecordList(pagesize, page, chat_name, userid, id, status) {
    return request({
        url: '/hkt/customerbasemasssend/get_customer_base_mass_send_record_list',
        params: {
            pagesize,
            page,
            chat_name,
            userid,
            id,
            status
        }
    })
}
// 群主记录列表
export function getCustomerBaseMassSendOwnerRecordList(pagesize, page, userid, id, status) {
    return request({
        url: '/hkt/customerbasemasssend/get_customer_base_mass_send_owner_record_list',
        params: {
            pagesize,
            page,
            userid,
            id,
            status
        }
    })
}



// 客户群任务
// 任务列表
export function getCustomerBaseTaskList(pagesize, page, name) {
    return request({
        url: '/hkt/customerbasetask/get_customer_base_task_list',
        params: {
            pagesize,
            page,
            name
        }
    })
}
// 创建任务
export function addCustomerBaseTask(name, content) {
    return request({
        url: '/hkt/customerbasetask/add_customer_base_task',
        params: {
            name,
            content
        }
    })
}
// 删除任务
export function delCustomerBaseTask(id) {
    return request({
        url: '/hkt/customerbasetask/del_customer_base_task',
        params: {
            id
        }
    })
}
// 任务开关
export function setCustomerBaseTaskLock(id, is_lock) {
    return request({
        url: '/hkt/customerbasetask/set_customer_base_task_lock',
        params: {
            id,
            is_lock
        }
    })
}
// 客户群任务
export function getCustomerBaseTask(id) {
    return request({
        url: '/hkt/customerbasetask/get_customer_base_task',
        params: {
            id,
        }
    })
}
// 编辑任务
export function editCustomerBaseTask(id, name, content) {
    return request({
        url: '/hkt/customerbasetask/edit_customer_base_task',
        params: {
            id,
            name,
            content
        }
    })
}
// 添加群聊
export function setCustomerBaseTaskBase(id, customer_base_id) {
    return request({
        url: '/hkt/customerbasetask/set_customer_base_task_base',
        params: {
            id,
            customer_base_id
        }
    })
}